// The shapes that mark an intentionally cancelled request: DOM AbortError (fetch, AbortController, media play()) and axios CanceledError/ERR_CANCELED. Read by isAbortError for live errors and by isSerializedAbortException for the PostHog wire shape, where the name is folded into the value.
export const ABORT_ERROR_NAMES: readonly string[] = [
  "AbortError",
  "CanceledError",
];
export const ABORT_ERROR_CODE = "ERR_CANCELED";
